import { Injectable } from "@angular/core";
import { pingIdToken,environmentPingId } from "src/environments/environment";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from "rxjs";
import { HelperService } from "../helperService";
@Injectable({
    providedIn: 'root'
})
export class APIPingIdservice {
    
    ApiURL: string = "";
    
    constructor(private http: HttpClient) {
        this.ApiURL =environmentPingId.PingIdTokenUrl
    }

    public getTokenPingId(): Observable<any>{
            const urlencoded = new URLSearchParams();
             urlencoded.append("client_id", pingIdToken.clientId);
             urlencoded.append("client_secret", pingIdToken.clientSecret);
             urlencoded.append("grant_type", "client_credentials");

        const headers = new HttpHeaders().set('content-type', `application/x-www-form-urlencoded`);
        const requestOptions = {
            headers: headers,
        };
        return this.http.post<any[]>(this.ApiURL,urlencoded,requestOptions);
    }

  
 
}

    
